import {createSlice} from "@reduxjs/toolkit";

const unAuthorizedPageSlice = createSlice({
    name: "unAuthorizedPage",
    initialState: false,
    reducers:{        
        setUnAuthorizedPageOn: (state, action) => (true),
        setUnAuthorizedPageOff: (state, action) => (false)
    }
});

export const { setUnAuthorizedPageOn, setUnAuthorizedPageOff } = unAuthorizedPageSlice.actions;

export default unAuthorizedPageSlice.reducer;